import { resetInText } from '@penalty-cup/shared';
import { useEffect, useState } from 'react';
import { useApp } from '../store.js';
import { SlotOffer } from './SlotOffer.js';

/** «🎟 Билеты 2 / 3 · +3 через 5 ч»; нет билетов — «Купить билет». */
export function TicketsBar() {
  const me = useApp((s) => s.me);
  const open = useApp((s) => s.openTicketModal);
  // Таймер до восстановления — раз в минуту
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(id);
  }, []);
  if (!me) return null;
  const t = me.tickets;
  const restoring = t.free < t.freeMax;
  return (
    <div className="tickets" aria-label="Турнирные билеты">
      <span className="tickets__count">
        🎟 <b>{t.free}</b> / {t.freeMax}
        {t.purchased > 0 && <span className="tickets__extra"> +{t.purchased}</span>}
      </span>
      <SlotOffer />
      {t.total === 0 && (
        <button type="button" className="chip chip--small chip--on" onClick={() => open(8)}>
          Купить билет
        </button>
      )}
      {restoring && (
        <span className="tickets__reset">
          +{t.freeMax} через {resetInText(t.nextResetAt, now)}
        </span>
      )}
    </div>
  );
}
